import { type ThemeOptions } from "@mui/material";
import { type Settings } from "@ui-kit/theme/types";
import { type ThemeColor } from "@ui-kit/theme/types";
import { DefaultPalette as palette } from "./palette";
import { spacing } from "./spacing";
import { Shadows as shadows } from "./shadows";
import { breakpoints } from "./breakpoints";

const themeOptions = (settings: Settings): ThemeOptions => {
  const { themeColor } = settings;

  const themeConfig = {
    palette: palette(themeColor as ThemeColor),
    typography: {
      fontFamily: [
        "Inter",
        "sans-serif",
        "-apple-system",
        "BlinkMacSystemFont",
        '"Segoe UI"',
        "Roboto",
        '"Helvetica Neue"',
        "Arial",
        "sans-serif",
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(","),
    },
    shadows: shadows(),
    ...spacing,
    breakpoints: breakpoints(),
    shape: {
      borderRadius: 6,
    },
    mixins: {
      toolbar: {
        minHeight: 64,
      },
    },
  };

  const basePalette = themeConfig.palette;
  const selectedColorPalette =
    basePalette[themeColor as keyof typeof basePalette];

  if (
    selectedColorPalette &&
    typeof selectedColorPalette === "object" &&
    "main" in selectedColorPalette
  ) {
    return {
      ...themeConfig,
      palette: {
        ...basePalette,
        primary: selectedColorPalette,
      },
    };
  }

  return themeConfig;
};

export { themeOptions };
